var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link.type === 'url')?_c('a',{attrs:{"href":_vm.link.data}},[_vm._t("default")],2):(_vm.link.type === '')?_c('div',[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.dealLink(_vm.link)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }